import { DISTANCE_BETWEEN_MONAKO_AND_NICE_AIRPORT_KM } from 'common/constants/map-point';
import { FromAirportTransport } from 'common/types';
import { Co2FootprintVO } from 'vo';

// TODO: think about move this logic to calculate-movement.ts

const getCo2ePerKmByTransport = (transport: FromAirportTransport) => {
  /**
   * Emission factors updated January 2026.
   * Source: UK DESNZ/DEFRA Greenhouse Gas Conversion Factors 2025
   * https://www.gov.uk/government/publications/greenhouse-gas-reporting-conversion-factors-2025
   */
  const mapping: Record<FromAirportTransport, number> = {
    [FromAirportTransport.TAXI]: 0.14549, // Regular taxi (DEFRA 2025)
    [FromAirportTransport.BUS]: 0.10385, // Average local bus (DEFRA 2025)
    [FromAirportTransport.TRAIN]: 0.03546, // National rail (DEFRA 2025)

    [FromAirportTransport.HELICOPTER]: 9.8394, // BAZL helicopter emissions methodology
  };

  return mapping[transport];
};

type Params = {
  peopleCount: number;
  transport: FromAirportTransport;
};

export default (params: Params) => {
  const { peopleCount, transport } = params;

  const perKm = getCo2ePerKmByTransport(transport);
  const perPerson = perKm * DISTANCE_BETWEEN_MONAKO_AND_NICE_AIRPORT_KM;
  const total = perPerson * peopleCount;

  return Co2FootprintVO.create({ perPerson, total });
};
